
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M3.16002 3.16C2.77002 2.77 2.14002 2.77 1.75002 3.16C1.36002 3.55 1.36002 4.18 1.75002 4.57L6.35002 9.17L6.14002 9.4H3.60002C2.72002 9.4 2.00002 10.12 2.00002 11V20.4C2.00002 21.28 2.72002 22 3.60002 22H16.4C17.15 22 17.78 21.48 17.95 20.78L19.42 22.25C19.81 22.64 20.44 22.64 20.83 22.25C21.22 21.86 21.22 21.23 20.83 20.84L3.16002 3.16ZM10 20C7.79002 20 6.00002 18.21 6.00002 16C6.00002 14.05 7.40002 12.43 9.25002 12.08L10.82 13.65C10.56 13.56 10.29 13.5 10 13.5C8.62002 13.5 7.50002 14.62 7.50002 16C7.50002 17.38 8.62002 18.5 10 18.5C11.38 18.5 12.5 17.38 12.5 16C12.5 15.71 12.44 15.44 12.35 15.18L13.92 16.75C13.57 18.6 11.95 20 10 20ZM18 15.17L10.83 8H11.7C12.26 8 12.8 8.24 13.18 8.65L13.87 9.4H16.41C17.29 9.4 18.01 10.12 18.01 11V15.17H18ZM20.4 5.6H21.15C21.53 5.6 21.77 6.01 21.59 6.34L19 11V7H18.5C18.22 7 18 6.78 18 6.5V2.5C18 2.22 18.22 2 18.5 2H21.23C21.59 2 21.83 2.37 21.69 2.7L20.4 5.6Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-no-flash`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconNoFlash

    ```js
    <b-new-b-icon-no-flash />
    ```
</docs>


